import httpClient from '../httpClient';

export const getAllContratos = async () => {
  try {
    const response = await httpClient.get(`/api/contrato`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export async function getContratosByUsuario() {
  try {
    const response = await httpClient.get(
      `/api/contrato/contratos-por-usuario`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter contratos do usuário: ' + error);
  }
}

export async function getContrato(id: string) {
  try {
    const response = await httpClient.get(`/api/contrato/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function handleCreateContrato(form: any) {
  try {
    const response = await httpClient.post(`/api/contrato`, form);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateContrato(form: any) {
  try {
    const response = await httpClient.patch(`/api/contrato/${form.id}`, form);

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteContrato(id: string | number) {
  try {
    return await httpClient.delete(`/api/contrato/${id}`);
  } catch (error) {
    throw error;
  }
}
